(function (app, ng) {
    app.component("transactionGroupWorkflows",
        {
            controller: transactionGroupWorkflowsController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/template.html",
            bindings: {
                transactionGroup: "=",
                disclosePoints: "=",
                disclosures: "=",
                capturePoints: "=",
                requiredCaptureDocuments: "=",
                determinePoints: "=",
                requiredDetermineDocuments: "=",
                questionCategories: "=",
                stockQuestions: "=",
                publishedTransactionGroup: "<",
                publishedTransactionGroupQuestionCategories: "<",              
                onSave: "&"
            }
        });

    transactionGroupWorkflowsController.$inject = ["questionApi", "stockQuestionApi", "transactionGroupApi", "productApi", "$q"];
    function transactionGroupWorkflowsController(questionApi, stockQuestionApi, transactionGroupApi, productApi, $q) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    currentStage: 0,
                    transactionStages: [
                        { stage: "Disclose" },
                        { stage: "Capture" },
                        { stage: "Determine" },
                        { stage: "Application" },
                        { stage: "Review" },
                        { stage: "Overview"}
                    ]
                },
                onSaveLink: onSaveLink,
                navigateToDisclose: navigateToDisclose,
                navigateToCapture: navigateToCapture,
                navigateToDetermine: navigateToDetermine,
                navigateToApplication: navigateToApplication,
                navigateToReview: navigateToReview,
                navigateToOverview: navigateToOverview
            });

        function onSaveLink(func) {
            $ctrl.onSave({
                $func: func
            });
        }

        function navigateToDisclose() { $ctrl.UI.currentStage = 0; }

        function navigateToCapture() { $ctrl.UI.currentStage = 1; }

        function navigateToDetermine() { $ctrl.UI.currentStage = 2; }

        function navigateToApplication() { $ctrl.UI.currentStage = 3; }

        function navigateToReview() { $ctrl.UI.currentStage = 4; }

        function navigateToOverview() {
            var promises = [];
            promises.push(questionApi.getQuestionCategories($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.questionCategories = response;
                stockQuestionApi.getAllStockQuestions().then(function (r) {
                    $ctrl.stockQuestions = r;
                    $ctrl.UI.currentStage = 5;
                });
            }).catch(ng.noop));
            promises.push(productApi.getActiveProducts()
                .then(function (response) {
                    $ctrl.products = response;
                }));

            promises.push(transactionGroupApi.getQueueWorkflow($ctrl.transactionGroup.QueueWorkflowId).then(function(q) {
                $ctrl.queueWorkflow = q;
            }));

            promises.push(transactionGroupApi.getDisclosures($ctrl.transactionGroup.Id).then(function (response) {
                $ctrl.disclosures = response;
            }));

            $q.all(promises).then(function () {
                $ctrl.UI.CurrentView = 5;
            });
        }
    };

})(window.app, window.angular); //jshint ignore:line